export var EnvironmentEnum;
(function (EnvironmentEnum) {
    EnvironmentEnum["DEVELOPMENT"] = "Development";
    EnvironmentEnum["PRODUCTION"] = "Production";
})(EnvironmentEnum || (EnvironmentEnum = {}));
